import { DashboardOutlined,UsergroupAddOutlined,UploadOutlined} from '@ant-design/icons';
import { APP_PREFIX_PATH } from 'configs/AppConfig'

const dashBoardNavTree = [{
  key: 'home',
  path: `${APP_PREFIX_PATH}/home`,
  title: 'sidenav.home',
  icon: DashboardOutlined,
  breadcrumb: false,
  submenu: []
}]

const parentManage = [{
  key: 'parent',
  path: `${APP_PREFIX_PATH}/parent`,
  title: 'sidenav.parent',
  icon: '',
  breadcrumb: false,
  submenu: [
     {
      key: 'parent',
      path: `${APP_PREFIX_PATH}/parent`,
      title: 'sidenav.parent',
      icon: UsergroupAddOutlined ,
      breadcrumb: false,
      submenu:[
          {
            key: 'parent-addStudent',
            path: `${APP_PREFIX_PATH}/parent/addStudent`,
            title: 'sidenav.parent.addStudent',
            icon: '',
            breadcrumb: false,
            submenu: [            
            ]
          },
          {
          key: 'parent-all',
          path: `${APP_PREFIX_PATH}/parent/allparent`,
          title: 'sidenav.parent.all',
          icon: '',
          breadcrumb: false,
          submenu: []
          },
          {
            key: 'parent-community',
            path: `${APP_PREFIX_PATH}/parent/community`,
            title: 'sidenav.parent.community',
            icon: '',
            breadcrumb: false,
            submenu: [
             
            ]
          },
          {
            key: 'parent-new',
            path: `${APP_PREFIX_PATH}/parent/requests`,
            title: 'sidenav.parent.new',
            icon: '',
            breadcrumb: false,
            submenu: [
              {
                key: 'parent-new',
                path: `${APP_PREFIX_PATH}/parent/requests/enroll`,
                title: 'sidenav.parent.requests.enroll',
                icon: '',
                breadcrumb: false,
                submenu: []
              },
              {
                key: 'parent-new',
                path: `${APP_PREFIX_PATH}/parent/requests/drop`,
                title: 'sidenav.parent.requests.drop',
                icon: '',
                breadcrumb: false,
                submenu: []
              },
              {
                key: 'parent-new',
                path: `${APP_PREFIX_PATH}/parent/requests/history`,
                title: 'sidenav.parent.requests.history',
                icon: '',
                breadcrumb: false,
                submenu: [
                  {
                    key: 'parent-new',
                    path: `${APP_PREFIX_PATH}/parent/requests/history/enroll`,
                    title: 'sidenav.parent.requests.history',
                    icon: '',
                    breadcrumb: false,
                    submenu: []
                  },
                  {
                    key: 'parent-new',
                    path: `${APP_PREFIX_PATH}/parent/requests/history/drop`,
                    title: 'sidenav.parent.requests.history',
                    icon: '',
                    breadcrumb: false,
                    submenu: []
                  },
                ]
              },
              
            ]
          }
      ]
    } ,
  ]
}
]

const rmManage = [{
  key: 'rm',
  path: `${APP_PREFIX_PATH}/rm`,
  title: 'sidenav.rm',
  icon: '',
  breadcrumb: false,
  submenu: [
     {
      key: 'rm',
      path: `${APP_PREFIX_PATH}/rm`,
      title: 'sidenav.rm',
      icon: UsergroupAddOutlined ,
      breadcrumb: false,
      submenu:[
        {
          key: 'rm-all',
          path: `${APP_PREFIX_PATH}/rm/all`,
          title: 'sidenav.rm.all',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
        // {
        //   key: 'rm-add',
        //   path: `${APP_PREFIX_PATH}/rm/add`,
        //   title: 'sidenav.rm.addRM',
        //   icon: '',
        //   breadcrumb: false,
        //   submenu: []
        // },
        {
          key: 'rm-audit',
          path: `${APP_PREFIX_PATH}/rm/audit`,
          title: 'sidenav.rm.audit',
          icon: '',
          breadcrumb: false,
          submenu: []
          },
          {
            key: 'rm-rating',
            path: `${APP_PREFIX_PATH}/rm/rating`,
            title: 'sidenav.rm.rating',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
          {
            key: 'rm-report',
            path: `${APP_PREFIX_PATH}/rm/report`,
            title: 'sidenav.rm.report',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
          {
            key: 'rm-RMAttendance',
            path: `${APP_PREFIX_PATH}/rm/RMAttendance`,
            title: 'sidenav.rm.rmAttendance',
            icon: '',
            breadcrumb: false,
            submenu: []
          },
          {
            key: 'fill-Evening',
            path: `${APP_PREFIX_PATH}/rm/FillEveningResponse`,
            title: 'sidenav.rm.FillEveningResponse',
            icon: '',
            breadcrumb: false,
            submenu: []
          
          },
          {
            key: 'pay-History',
            path: `${APP_PREFIX_PATH}/rm/PaymentHistory`,
            title: 'Payment History',
            icon: '',
            breadcrumb: false,
            submenu: []
          }
      ]
    } ,
  ]
}
]

const operations = [{
  key: 'operations',
  path: `${APP_PREFIX_PATH}/operations`,
  title: 'sidenav.operations',
  icon: '',
  breadcrumb: false,
  submenu: [
     {
      key: 'operations',
      path: `${APP_PREFIX_PATH}/operations`,
      title: 'sidenav.operations',
      icon: UsergroupAddOutlined ,
      breadcrumb: false,
      submenu:[
        {
          key: 'math',
          path: `${APP_PREFIX_PATH}/operations/mathResponse`,
         title: 'sidenav.operations.mathResponse',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
        
        {
          key: 'english',
          path: `${APP_PREFIX_PATH}/operations/englishResponse`,
         title: 'sidenav.operations.englishResponse',
          icon: '',
          breadcrumb: false,
          submenu: []
          },
         
        
      ]
    } ,
  ]
}
]
const upload = [{
  key: 'upload',
  path: `${APP_PREFIX_PATH}/upload`,
  title: 'sidenav.upload',
  icon: '',
  breadcrumb: false,
  submenu: [
     {
      key: 'upload',
      path: `${APP_PREFIX_PATH}/upload`,
      title: 'sidenav.upload',
      icon: UploadOutlined ,
      breadcrumb: false,
      submenu:[
        {
          key: 'student details',
          path: `${APP_PREFIX_PATH}/upload/student`,
          title: 'sidenav.upload.studentDeatils',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
         {
          key: 'rm details',
          path: `${APP_PREFIX_PATH}/upload/rm`,
          title: 'sidenav.upload.rmDeatils',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'morning details',
          path: `${APP_PREFIX_PATH}/upload/morning`,
          title: 'sidenav.upload.morningResponse',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
        {
          key: 'worksheet details',
          path: `${APP_PREFIX_PATH}/upload/worksheet`,
          title: 'sidenav.upload.worksheetDetails',
          icon: '',
          breadcrumb: false,
          submenu: []
        },
      ]
    } ,
  ]
}
]
// const helpAndSupport = [{
//   key: 'helpAndSupport',
//   path: `${APP_PREFIX_PATH}/helpAndSupport`,
//   title: 'sidenav.hAS',
//   icon: '',
//   breadcrumb: false,
//   submenu: [
//      {
//       key: 'helpAndSupport',
//       path: `${APP_PREFIX_PATH}/helpAndSupport`,
//       title: 'sidenav.hAS',
//       icon: UploadOutlined ,
//       breadcrumb: false,
//       submenu:[
//         {
//           key: 'helpAndSupport-raiseProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/raiseProblem`,
//           title: 'sidenav.hAS.raiseProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'helpAndSupport-pastProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/pastProblem`,
//           title: 'sidenav.hAS.pastProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'helpAndSupport-rmProblem',
//           path: `${APP_PREFIX_PATH}/helpAndSupport/rmProblem`,
//           title: 'sidenav.hAS.rmProblem',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//           },
//       ]
//     } ,
//   ]
// }
// ]


// const inventoryManage = [{
//   key: 'inventory',
//   path: `${APP_PREFIX_PATH}/inventory`,
//   title: 'sidenav.inventory',
//   icon: '',
//   breadcrumb: false,
//   submenu: [
//      {
//       key: 'inventory',
//       path: `${APP_PREFIX_PATH}/inventory`,
//       title: 'sidenav.inventory',
//       icon: UsergroupAddOutlined ,
//       breadcrumb: false,
//       submenu:[
//         {
//           key: 'inventory-received',
//           path: `${APP_PREFIX_PATH}/inventory/received`,
//           title: 'sidenav.inventory.received',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//         },
//         {
//           key: 'inventory-send',
//           path: `${APP_PREFIX_PATH}/inventory/send`,
//           title: 'sidenav.inventory.send',
//           icon: '',
//           breadcrumb: false,
//           submenu: []
//           },
//           {
//             key: 'inventory-return',
//             path: `${APP_PREFIX_PATH}/inventory/return`,
//             title: 'sidenav.inventory.return',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-CLstock',
//             path: `${APP_PREFIX_PATH}/inventory/CLstock`,
//             title: 'sidenav.inventory.CLstock',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-RMstock',
//             path: `${APP_PREFIX_PATH}/inventory/RMstock`,
//             title: 'sidenav.inventory.RMstock',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-audit',
//             path: `${APP_PREFIX_PATH}/inventory/audit`,
//             title: 'sidenav.inventory.audit',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           },
//           {
//             key: 'inventory-exchange',
//             path: `${APP_PREFIX_PATH}/inventory/exchange`,
//             title: 'sidenav.inventory.exchange',
//             icon: '',
//             breadcrumb: false,
//             submenu: []
//           }
//       ]
//     } ,
//   ]
// }
// ]

const navigationConfig = [ 
  ...dashBoardNavTree,
  ...parentManage ,
  ...rmManage,
  ...operations,
  ...upload
  // ...helpAndSupport,
  // ...inventoryManage,
]

export default navigationConfig;

